import Vue from "vue";

const modulo_clientes = {
    strict: false,

    state: {
        clientes: [],
        metodos_pago: [],
        current: 0,
        rol: null,
        cliente: {}
    },

    getters: {
        getclientes: (state) => state.clientes,
        getmetodoscliente: (state) => state.metodos_pago,
        getcliente: (state) => state.cliente,
    },

    mutations: {
        get_clientes: (state, clientes) => {
            state.clientes = clientes.data;
            state.page = 2;
        },
        update_clientes: (state, clientes) => {
            state.clientes = state.clientes.concat(clientes.data);
            state.page = clientes.current_page + 1;
        },
        add_search: (state, clientes) => {
            state.clientes = state.clientes.concat(clientes);
        },
        get_data_cliente: (state, data) => {
            state.cliente = Object.keys(data).filter(key => key !== "metodos_pago")
                .reduce((acc, key) => ({ ...acc, [key]: data[key] }), {});

            state.metodos_pago = data.metodos_pago;
        },
        change_rol_cliente: (state, data) => {
            state.rol = data;
        },
        add_cliente: (state, data) => {
            state.clientes.push(data);
        },
    },

    actions: {
        addCliente(context, vm) {
            context.commit("add_cliente", vm);
        },
        getClientes: (context, vm) => {
            let rol = null;
            if (vm?.rol != null) {
                rol = vm?.rol;
            }
            axios
                .get(
                    `api/get-clientes/15?page=1${
                        rol != null ? `&rol=${rol}` : ""
                    }`
                )
                .then(
                    (res) => {
                        context.commit("get_clientes", res.data);
                    },
                    (res) => {}
                );
        },
        getClientesWithId: (context, vm) => {
            axios.get(`api/get-clientes/15?page=1&cliente=${vm.id}`).then(
                (res) => {
                    context.commit("get_clientes", res.data.data);
                },
                (res) => {}
            );
        },
        getClientesNext: (context, vm) => {
            let rol = null;
            if (vm?.rol != null) {
                rol = vm?.rol;
            }
            axios
                .get(
                    `api/get-clientes/15?page=${context.state.page ?? 1}${
                        rol != null ? `&rol=${rol}` : ""
                    }`
                )
                .then(
                    (res) => {
                        context.commit("update_clientes", res.data);
                    },
                    (res) => {}
                );
        },
        searchCliente: (context, vm) => {
            let rol = null;
            if (vm?.rol != null) {
                rol = vm?.rol;
            }
            axios
                .get(
                    `api/get-clientes/30?page=1${
                        vm?.search ? `&busqueda=${vm?.search}` : ""
                    }${rol != null ? `&rol=${rol}` : ""}`
                )
                .then(
                    (res) => {
                        context.commit("update_clientes", res.data);
                    },
                    (res) => {}
                );
        },
        getDataCliente(context, vm) {
            axios.get(`api/getcliente/${vm}`).then(
                (res) => {
                    context.commit("get_data_cliente", res.data);
                },
                (res) => {}
            );
        },
    },
};

export default modulo_clientes;
